import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import ConfigurationContext from './ConfigurationContext';
const ConfigurationProvider = ({ children }) => {
    const [isOpenNotification, setIsOpenNotification] = useState(true);
    const contextValue = useMemo(() => ({
        isOpenNotification,
        setIsOpenNotification,
    }), [isOpenNotification]);
    return _jsx(ConfigurationContext.Provider, { value: contextValue, children: children });
};
export default ConfigurationProvider;
